module.exports = __webpack_public_path__ + "img/x18.bd59f99b.jpg";